import {
  AttributeType,
  ItemPageAttributesBlockPluginModel,
  ItemPageAttributesDto,
} from '@marketplace-web/domain/item-page-data'

const SUPPORTED_ATTRIBUTE_TYPES = Object.values(AttributeType)

export const getItemPageAttributesBlockPluginModel = (
  attributesPluginDto: ItemPageAttributesDto,
): ItemPageAttributesBlockPluginModel => ({
  attributes: attributesPluginDto.attributes.filter(attribute =>
    SUPPORTED_ATTRIBUTE_TYPES.includes(attribute.type),
  ),
  itemId: attributesPluginDto.item_id,
})
